import React, { FC } from "react";
import styled from "styled-components";
import { LinearProgress } from "@evergis/ui";

const AttributesLoaderContainer = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 5;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: baseline;
  background: rgba(255, 255, 255, 0.46);

  ${LinearProgress} {
    width: 52rem;
    margin-top: auto;
  }
`;

export const AttributesLoader: FC = () => (
  <AttributesLoaderContainer>
    <LinearProgress />
  </AttributesLoaderContainer>
);
